module.exports = __webpack_public_path__ + "img/sg-thumb.b41268fa.jpg";